import { atomFamily, useRecoilState } from 'recoil';

const cacheFamily = atomFamily({
  key: 'cache',
  default: {
    value: undefined,
    expires: 0,
  },
});

const useCache = ({
  category = 'default',
  key,
}) => useRecoilState(cacheFamily(`${category}.${key}`));

const resolveCache = (
  [entry, setEntry],
  resolver = Promise.resolve(),
  expires,
) => new Promise((resolve, reject) => {
  const now = Date.now();
  if (entry?.expires > now) {
    return resolve(entry.value);
  }
  resolver().then((resolved) => {
    setEntry({
      expires: now + (expires || 10 * 60000), // 10min default
      value: resolved,
    });
    resolve(resolved);
  }).catch((rejected) => {
    reject(rejected);
  });
  return true;
});

export { useCache, resolveCache };
